var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M422.957,478.609h-16.696v-89.044c0-58.16-33.276-108.601-81.734-133.565c48.954-25.22,81.734-75.864,81.734-133.565 V33.391h16.696c9.217,0,16.696-7.473,16.696-16.696C439.652,7.473,432.174,0,422.957,0C355.995,0,156.678,0,89.044,0 c-9.217,0-16.696,7.473-16.696,16.696c0,9.223,7.479,16.696,16.696,16.696h16.696v89.044c0,57.692,32.771,108.341,81.734,133.565 c-48.459,24.964-81.734,75.405-81.734,133.565v89.044H89.044c-9.217,0-16.696,7.473-16.696,16.696 c0,9.223,7.479,16.696,16.696,16.696c111.521,0,222.498,0,333.913,0c9.217,0,16.696-7.473,16.696-16.696 C439.652,486.082,432.174,478.609,422.957,478.609z M139.641,132.511c-0.817-9.509-0.511-5.456-0.511-99.12H372.87 c0,93.664,0.306,89.611-0.511,99.12H139.641z M372.87,459.661c-92.104-76.755-88.747-75.372-100.174-79.41v-18.512 c0-9.223-7.479-16.696-16.696-16.696s-16.696,7.473-16.696,16.696v18.511c-11.307,3.996-7.768,2.403-100.174,79.41v-70.095 c0-58.759,43.63-107.391,100.174-115.536v20.927c0,9.223,7.479,16.696,16.696,16.696s16.696-7.473,16.696-16.696v-20.927 c56.544,8.145,100.174,56.777,100.174,115.536V459.661z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.a6954e0cd7de2deac1f955fd1b86a488.svg";
export { ForwardRef as ReactComponent };